import { IconDateTime16, Icon3DTour16, IconVideo16 } from '@cian/ui-kit';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  EPhotoFeatureIconsType,
  IPhotoFeatureIcons,
} from '../../../../../../../shared/repositories/search-offers.legacy/v2/types/photoFeatureIcons';
import { selectExperiments } from '../../../../../../../shared/selectors/selectExperiments';
import { useApplicationContext } from '../../../../../../../shared/utils/applicationContext';
import { is3DToursExperimentActive } from '../../../../../../../shared/utils/experiments/is3DToursExperimentActive';
import { FeatureLabel } from '../../../../components/FeatureLabel';
import { FeatureLabels } from '../../../../components/FeatureLabels';
import { useOfferContext } from '../../../../context';

const assetMap: { [index: string]: React.ReactNode } = {
  has3dTour: <Icon3DTour16 color={'white_100'} data-name="3D-tour-icon" />,
  hasFlatTourBooking: <IconDateTime16 color={'white_100'} />,
  hasVideo: <IconVideo16 color={'white_100'} />,
};

export function FeatureLabelsContainer() {
  const { config } = useApplicationContext();
  const { offer } = useOfferContext();
  const { photoFeatureIcons } = offer;
  const experiments = useSelector(selectExperiments);

  if (!photoFeatureIcons) {
    return null;
  }

  let filteredIcons = [...photoFeatureIcons];

  const isExternalTourEnabled = !!config.get<boolean>('external_tour_enabled.Enabled');
  const isTourExpActive = is3DToursExperimentActive(experiments);

  if (offer.isExternalTourAvailable && (!isExternalTourEnabled || !isTourExpActive)) {
    filteredIcons = [...photoFeatureIcons.filter(icon => icon.type !== EPhotoFeatureIconsType.Has3dTour)];
  }

  return (
    <FeatureLabels>
      {filteredIcons.map((icon: IPhotoFeatureIcons, index) => {
        return <FeatureLabel key={index} icon={assetMap[icon.type]} title={icon.text} />;
      })}
    </FeatureLabels>
  );
}
